import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {ErrorCorrectReportModel} from "./error-correct-report.model";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-error-correct-report-page",
    templateUrl: "./error-correct-report-page.component.html",
    providers: [provideReportModel(ErrorCorrectReportModel)]
})
export class ErrorCorrectReportPageComponent extends AbstractReportPage {

    constructor(public model: ErrorCorrectReportModel) {
        super();
    }
}
